// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recruitsGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
  border-radius: 0px !important;
  width: 97% !important;
  height: 64vh;
}
.recruitsGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-15wwp11-MuiTableHead-root {
  height: 0px !important;
}
.recruitsGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-y8ay40-MuiTableCell-root {
  background-color: white !important;
  border: 0px !important;
}
.recruitsGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .css-1ex1afd-MuiTableCell-root {
  background-color: #D9D9D9;
  border-bottom: 28px solid white !important;
}
.recruitsGrid .css-11xur9t-MuiPaper-root-MuiTableContainer-root .profilePicCell {
  background-color: white !important;
}
.recruitsGrid .css-13xy2my {
  border-radius: 0px !important;
  width: 97% !important;
  height: 64vh;
}
.recruitsGrid .css-13xy2my .css-1wbz3t9 {
  height: 0px !important;
}
.recruitsGrid .css-13xy2my .css-8coetn {
  background-color: white !important;
  border: 0px !important;
}
.recruitsGrid .css-13xy2my .css-q34dxg {
  background-color: #D9D9D9;
  border-bottom: 28px solid white !important;
}

.form-questions {
  font-size: 17px !important;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.67);
}

.text-field-container {
  justify-content: space-between;
  width: 65%;
}
.text-field-container .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 10px !important;
}
.text-field-container .css-1x5jdmq {
  height: 10px !important;
}
.text-field-container .text-field .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  height: 45px;
  width: 345px;
}
.text-field-container .text-field .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-srn6bb-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 44px;
}
.text-field-container .text-field .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
  height: 6vh;
}
.text-field-container .text-field .css-1v4ccyo {
  height: 45px;
  width: 345px;
}
.text-field-container .text-field .css-segi59 {
  height: 6vh;
}

.css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input {
  height: 0px !important;
}

.css-1ufn0jl {
  height: 5vh;
}

.css-1x5jdmq {
  height: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Recruits/style.scss"],"names":[],"mappings":"AACG;EACG,6BAAA;EACA,qBAAA;EACA,YAAA;AAAN;AAEM;EACG,sBAAA;AAAT;AAGM;EACG,kCAAA;EACA,sBAAA;AADT;AAIM;EACG,yBAAA;EACA,0CAAA;AAFT;AAQM;EACG,kCAAA;AANT;AAWG;EACG,6BAAA;EACA,qBAAA;EACA,YAAA;AATN;AAWM;EACG,sBAAA;AATT;AAYM;EACG,kCAAA;EACA,sBAAA;AAVT;AAaM;EACG,yBAAA;EACA,0CAAA;AAXT;;AAiBA;EACG,0BAAA;EACA,4BAAA;EACA,0BAAA;AAdH;;AAiBA;EACG,8BAAA;EACA,UAAA;AAdH;AAgBG;EACG,uBAAA;AAdN;AAiBG;EACG,uBAAA;AAfN;AAoBM;EACG,YAAA;EACA,YAAA;AAlBT;AAqBM;EACG,YAAA;AAnBT;AAsBM;EACG,WAAA;AApBT;AAwBM;EACG,YAAA;EACA,YAAA;AAtBT;AAyBM;EACG,WAAA;AAvBT;;AA6BA;EACG,sBAAA;AA1BH;;AA+BA;EACG,WAAA;AA5BH;;AA+BA;EACG,sBAAA;AA5BH","sourcesContent":[".recruitsGrid {\r\n   .css-11xur9t-MuiPaper-root-MuiTableContainer-root {\r\n      border-radius: 0px !important;\r\n      width: 97% !important;\r\n      height: 64vh;\r\n\r\n      .css-15wwp11-MuiTableHead-root {\r\n         height: 0px !important;\r\n      }\r\n\r\n      .css-y8ay40-MuiTableCell-root {\r\n         background-color: white !important;\r\n         border: 0px !important;\r\n      }\r\n\r\n      .css-1ex1afd-MuiTableCell-root {\r\n         background-color: #D9D9D9;\r\n         border-bottom: 28px solid white !important;\r\n         //   .profilePicCell{\r\n         //    background-color: white !important;\r\n         //   }\r\n      }\r\n\r\n      .profilePicCell {\r\n         background-color: white !important;\r\n      }\r\n   }\r\n\r\n   //For deployment\r\n   .css-13xy2my {\r\n      border-radius: 0px !important;\r\n      width: 97% !important;\r\n      height: 64vh;\r\n\r\n      .css-1wbz3t9 {\r\n         height: 0px !important;\r\n      }\r\n\r\n      .css-8coetn {\r\n         background-color: white !important;\r\n         border: 0px !important;\r\n      }\r\n\r\n      .css-q34dxg {\r\n         background-color: #D9D9D9;\r\n         border-bottom: 28px solid white !important;\r\n      }\r\n   }\r\n\r\n}\r\n\r\n.form-questions {\r\n   font-size: 17px !important;\r\n   font-weight: bold !important;\r\n   color: rgb(0 0 0 / 67%);\r\n}\r\n\r\n.text-field-container {\r\n   justify-content: space-between;\r\n   width: 65%;\r\n\r\n   .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\r\n      height: 10px !important;\r\n   }\r\n\r\n   .css-1x5jdmq {\r\n      height: 10px !important;\r\n   }\r\n\r\n   .text-field {\r\n\r\n      .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\r\n         height: 45px;\r\n         width: 345px;\r\n      }\r\n\r\n      .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-srn6bb-MuiAutocomplete-root .MuiOutlinedInput-root {\r\n         height: 44px;\r\n      }\r\n\r\n      .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {\r\n         height: 6vh;\r\n      }\r\n\r\n      //For deployment\r\n      .css-1v4ccyo {\r\n         height: 45px;\r\n         width: 345px;\r\n      }\r\n\r\n      .css-segi59 {\r\n         height: 6vh;\r\n      }\r\n   }\r\n}\r\n\r\n\r\n.css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input {\r\n   height: 0px !important;\r\n}\r\n\r\n\r\n//For deployment search field\r\n.css-1ufn0jl {\r\n   height: 5vh;\r\n}\r\n\r\n.css-1x5jdmq {\r\n   height: 0px !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n// .text-field{\r\n\r\n//    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{\r\n//       height:45px;\r\n//       width:345px;\r\n//    }\r\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
